import React from 'react'
import { Eye, EyeSlash } from 'react-bootstrap-icons'
import { useReadOnly } from '../../contexts/ReadOnlyContext'

export default function Switch({
  name,
  onChange = () => {},
  value,
  eyeSwitch = false,
  disabled = false
}) {
  const readOnly = useReadOnly()
  const isDisabled = disabled || readOnly

  return (
    <div className={isDisabled ? 'opacity-60 pointer-events-none' : ''}>
      <label className={`${eyeSwitch ? 'flex items-center justify-center' : ''} switch`}>
        <input
          checked={value}
          name={name}
          onChange={onChange}
          type="checkbox"
          disabled={isDisabled}
        />
        {
          eyeSwitch ? (
            <span className="flex items-center justify-center">
              { value ? <Eye className="text-rb-green" /> : <EyeSlash className="text-gray-400" />}
            </span>
          ) : (
            <span className={`slider ${value ? 'bg-rb-green' : 'bg-gray-400'}`}></span>
          )
        }
      </label>
    </div>
  )
}
